export const ALTO_INSIGHTS_EVENT_NAMES = {
  VIEWED_ALTO_INSIGHTS: 'Viewed Alto Insights',
  REQUESTS_TILE: 'Viewed Requests tile',
  CONVERSION_RATE_TILE: 'Viewed Conversion Rate tile',
  BOOKINGS_TILE: 'Viewed Bookings tile',
  EXTENSIONS_TILE: 'Viewed Extensions tile',
  BOOKED_NIGHTS_TILE: 'Viewed Booked Nights tile',
  AVERAGE_DAILY_RATE_TILE: 'Viewed Average Daily Rate tile',
  REFERRAL_FEES_TILE: 'Viewed Referral Fees tile',
  SAVINGS_BOOKED_VS_BUDGET_TILE: 'Viewed Savings Booked vs Budget tile',
  TOTAL_SPEND_TILE: 'Viewed Total Spend tile',
  CSAT_TILE: 'Viewed CSAT tile',
  KEY_STATS_TAB: 'Viewed Key Stats and Financials tab',
  BOOKING_STATS_TAB: 'Viewed Booking Stats tab',
  TOP_LISTS_TAB: 'Viewed Top Lists tab',
  ESCALATIONS_TAB: 'Viewed Escalations tab',
  EXPORT_ESCALATIONS: 'Clicked Export Escalations',
  UNIT_TYPE_FILTER: 'Used Unit Type filter',
  PROPERTY_TYPE_FILTER: 'Used Property type filter',
  REGION_FILTER: 'Used Region filter',
  CURRENCY_FILTER: 'Used Currency filter',
  COUNTRY_FILTER: 'Used Country filter',
  CITY_FILTER: 'Used City filter',
  CORPORATE_FILTER: 'Used Corporate filter',
  CONSULTANT_FILTER: 'Used Consultant filter',
  CLIENT_FILTER: 'Used Client filter',
  ALTOVITIAN_FILTER: 'Used Altovitian filter',
  RMC_FILTER: 'Used RMC filter',
  DATE_RANGE_FILTER: 'Used Date Range filter',
} as const
